<div class="failed-payment-container">
    <div class="failed-payment-icon">&#10060;</div>
    <div class="failed-payment-message">Payment Failed</div>
    <div class="instructions">Yo the way your checking and savings is set up... it aint go through. Please try again.
    </div>
    <button class="try-again-button" (click)="tryAgain()">Try Again</button>
</div>